import { render } from "./CreateShare.vue?vue&type=template&id=6f9e03b9"
import script from "./CreateShare.vue?vue&type=script&lang=js"
export * from "./CreateShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__